import { ModalBody, ModalFooter, ModalTitle, Text } from '@serodigital/ui-components';
import { SeroProps } from '@serodigital/ui-components/dist/types/SeroProps';
import * as React from 'react';

export type DeleteModalProps = {
  onCancel: () => void;
  onConfirm: () => void;
  title: string;
  body: string;
  confirmLabel?: string;
} & SeroProps;

export function DeleteModal({ onCancel, onConfirm, title, body, confirmLabel, 'data-qa': dataQa }: DeleteModalProps) {
  return (
    <>
      <ModalTitle headerClassName="ml-0 mb-8">{title}</ModalTitle>
      <ModalBody>
        <div>
          <Text>{body}</Text>
        </div>
      </ModalBody>
      <ModalFooter
        data-qa={`${dataQa}-submit`}
        onCancel={onCancel}
        onConfirm={onConfirm}
        confirmLabel={confirmLabel || 'Yes, Delete'}
      />
    </>
  );
}
